(function() {
    'use strict';

    angular
        .module('app')
        .controller('courseCategorySelectorController', courseCategorySelectorController);

    function courseCategorySelectorController($q, $rootScope, $scope, $uibModalInstance, trainingInnerService, categoryItem) {
        var vm = this;
        vm.cancel = cancel;
        vm.itemSelected = itemSelected;

        onInit();

        function onInit() {
            console.log('categoryItem:', categoryItem);
            vm.courseCategory = categoryItem;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function itemSelected(item) {
            var result = [];
            //courseItem.selectedItemName = item.showName;
            result.push(item);
            $uibModalInstance.close(result);
        }
    }
})();